import { render } from "./EditWordList.vue?vue&type=template&id=47f0a0c5&scoped=true"
import script from "./EditWordList.vue?vue&type=script&lang=ts"
export * from "./EditWordList.vue?vue&type=script&lang=ts"

import "./EditWordList.vue?vue&type=style&index=0&id=47f0a0c5&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-47f0a0c5"

export default script